import { cn } from '@/lib/utils'

/** Pill buttons in the instrument style. */
export const buttonClass = (variant: 'primary' | 'outline' | 'quiet' = 'primary', className?: string): string => cn(
    'label-mono inline-flex items-center justify-center gap-2 rounded-full transition-colors duration-500 disabled:cursor-not-allowed disabled:opacity-45',
    variant === 'primary' && 'h-12 bg-brass px-7 text-ink hover:bg-star',
    variant === 'outline' && 'h-12 border border-brass/60 px-7 text-star hover:border-brass hover:bg-brass hover:text-ink',
    variant === 'quiet' && 'h-10 border border-hair-2 px-5 text-star-2 hover:border-brass hover:text-star',
    className
)
